import { cn } from '@/lib/utils'

import { CaseAlerts } from '../case-alerts/case-alerts'
import { CheckCaseProcessingTime } from './check-case-processing-time/check-case-processing-time'
import { CheckVisaBulletin } from './check-visa-bulletin/check-visa-bulletin'

export const CheckUscisCase = () => {
  return (
    <div className={cn('px-6')}>
      <h3 className={cn('text-base font-medium')}>Track Important Dates</h3>
      <div className={cn('mt-[18px]', 'space-y-3')}>
        <CheckCaseProcessingTime />
        <CheckVisaBulletin />
        <CaseAlerts />
      </div>
    </div>
  )
}
